'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FriendbuyWidget = exports.buildFriendbuyInterpolator = exports.getFriendbuyApi = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.extractRafRewards = extractRafRewards;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _bound = require('redux/saga/entities/bound');

var _scripts = require('helpers/scripts');

var _multitrack = require('helpers/multitrack');

var _interpolate = require('helpers/interpolate');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFriendbuyApi = exports.getFriendbuyApi = function getFriendbuyApi() {
  return __TEST__ ? global.testFriendbuy : window.friendbuy = window.friendbuy || [];
};

function extractRafRewards(user) {
  var friendBuyInfo = user && user.friendbuy_info || {};

  var currencyFormat = friendBuyInfo.currency_format || '';
  var rafFallbackRewardAmount = friendBuyInfo.referral_reward > 0 ? friendBuyInfo.referral_reward : '';
  return {
    rafSenderReward: friendBuyInfo.sender_reward || '' + currencyFormat + rafFallbackRewardAmount,
    rafReceiverReward: friendBuyInfo.receiver_reward || '' + currencyFormat + rafFallbackRewardAmount
  };
}
var buildFriendbuyInterpolator = exports.buildFriendbuyInterpolator = function buildFriendbuyInterpolator(state) {
  return function (str) {
    var profile = _bound.userProfile.data(state) || {};

    var _extractRafRewards = extractRafRewards(profile),
        rafSenderReward = _extractRafRewards.rafSenderReward,
        rafReceiverReward = _extractRafRewards.rafReceiverReward;

    return (0, _interpolate.interpolate)(str, {
      $FIRST_NAME: profile.first_name,
      $FRIENDBUY_REWARD: rafSenderReward,
      $SENDER_FIRST_NAME: profile.first_name,
      $SENDER_REWARD: rafSenderReward,
      $RECEIVER_REWARD: rafReceiverReward
    });
  };
};

var FriendbuyWidget = exports.FriendbuyWidget = function (_React$Component) {
  (0, _inherits3.default)(FriendbuyWidget, _React$Component);

  function FriendbuyWidget() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, FriendbuyWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = FriendbuyWidget.__proto__ || (0, _getPrototypeOf2.default)(FriendbuyWidget)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleWidgetClose = function (_ref2) {
      var groupId = _ref2.groupId,
          guid = _ref2.guid;

      // Tinker with friendbuy's internal state so we can re-open the widget
      var friendbuy = getFriendbuyApi();

      if (friendbuy.widgets) {
        delete friendbuy.widgets[guid];
      }

      if (friendbuy.widgetNames) {
        (0, _keys2.default)(friendbuy.widgetNames).forEach(function (name) {
          if (name.indexOf(groupId) === 0) {
            delete friendbuy.widgetNames[name];
          }
        });
      }

      var onClose = _this.props.onClose;


      if (onClose) {
        onClose();
      }
    }, _this2.handleShareSuccess = function () {
      return (0, _multitrack.ga)('Refer-a-Friend', 'raf-successfully-sent', window.location.pathname, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(FriendbuyWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          widgetCode = _props.widgetCode,
          userId = _props.userId,
          email = _props.email;


      if (!widgetCode) {
        logger.warn('FriendbuyWidget initiated without a widgetCode for user ' + userId + '.');
        return;
      }

      if (!__TEST__ && !window.friendbuy) {
        (0, _scripts.load)('//djnf6e5yyirys.cloudfront.net/js/friendbuy.min.js');
      }

      var friendbuy = getFriendbuyApi();
      friendbuy.push(['site', (0, _universalConfig2.default)().friendbuy.siteId]);
      friendbuy.push(['track', 'customer', {
        id: String(userId),
        email: email
      }]);

      friendbuy.push(['widget', widgetCode, {
        configuration: {
          share_button: false
        }
      }]);

      friendbuy.push(['subscribe', 'share.success', this.handleShareSuccess]);
      friendbuy.push(['subscribe', 'widget.close', this.handleWidgetClose]);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { className: 'text--center friendbuy-' + this.props.widgetCode });
    }
  }]);
  return FriendbuyWidget;
}(_react2.default.Component);

FriendbuyWidget.propTypes = {
  userId: _propTypes2.default.number.isRequired,
  email: _propTypes2.default.string.isRequired,
  widgetCode: _propTypes2.default.string.isRequired,
  onClose: _propTypes2.default.func
};